export default __webpack_public_path__ + "static/media/Breeches of Haloga.450b2f65.jpg";